import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import {selectUserIsAuthenticated} from "./stores/account/account.selectors";


const ProtectedRoute = ({ children }) => {
    const isUserAuthenticated = useSelector(selectUserIsAuthenticated);

    if (!isUserAuthenticated) {
        return <Navigate to="/lobby" />;
    }

    return children;
};

export default ProtectedRoute;